import { createContext, useContext } from 'react';
import { BevPageTypes } from '../BevPageTypes';

export const defaultContext: BevPageTypes.TBevContext = {
  height: 0,
  otherNavigationProps: {},
  nextRoute: '',
};

export const BevContext = createContext<BevPageTypes.TBevContext>(
  defaultContext
);
export const useBevContext = () => useContext(BevContext);
